<div class="row g-3 mb-3 d-print-none" *ngIf="listData?.projects?.length > 0">
	<div class="col-9">
	</div>
	<div class="col-3 text-end">
		<button (click)="onPrint()" class="btn btn-primary" id="btn-print">
			<i class="bi bi-printer"></i> Imprimir
		</button>
	</div>
</div>
<main class="relatorio4" *ngIf="listData?.projects?.length > 0">
  <ng-container *ngFor="let project of listData?.projects; let i = index">
    <div class="row-fluid box-title">
      <div class="col-10">
        <h1>Pré-Projeto {{ project.id }} - {{ project.title.toUpperCase() }}</h1>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="alert alert-danger">
      <ol>
        <li *ngFor="let warning of project?.warns1">
          {{warning.warn_msg}}
        </li>
      </ol>
    </div>
    <div class="row-fluid box-title">
      <div class="col-12">
        <h2>Cadastro</h2>
      </div>
      <hr/>
    </div>
    <div class="row-fluid">
      <div class="col-12">
          <form class="form-horizontal form-lazy-readonly" method="POST">
              <h3>I - Identificação</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Projeto</b>: {{ project.title }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Órgão Responsável</b>: {{ orgaoNome(project.agency_id) }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Situação Projeto</b>: {{ comboNome(listData?.situationList, project.situation_id, 'Projeto não iniciado') }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Gerente do Projeto</b>: {{ comboNome(listData?.personList, project.mainManger) }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Gerente Adjunto</b>: {{ arrayComboNome(listData?.personList, project.adjunctManagers) }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Proposta validada pelo gestor da Secretaria vinculante</b>: {{ comboNome(listData?.planAprovedlist, project.plan_approved, 'Não') }}
                  </div>
              </div>
              <h3>II - Escopo</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Situação problema</b>: {{ project.ds_problem }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Evidências da existência do problema na realidade brasileira e gaúcha</b>: {{ project.ds_problem_evidence }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Objeto</b>: {{ project.ds_object }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Objetivo</b>: {{ project.ds_objective }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Contexto e Justificativa</b>: {{ project.ds_reason }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Impactos esperados do projeto para sociedade</b>: {{ project.ds_impact_society }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Descreva práticas de referência para o projeto (benchmarking)</b>: {{ project.ds_benchmark }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Público-alvo (Beneficiários Diretos)</b>: {{ project.ds_target }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Número estimado do público-alvo</b>: {{ project.tot_direct_ben }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Beneficiários indiretos</b>: {{ project.ds_indirect_ben }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Número estimado dos beneficiários indiretos</b>: {{ project.tot_indirect_ben }}
                  </div>
              </div>
              <h3>III - Territorialização</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Nível Territorialização da Execução (onde será executado)</b>: {{ execComboType(listData?.localExecTypelist, project.local_exec_type, 'Estado') }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>{{execComboType(listData?.localExecTypelist, project.local_exec_type, 'Estado')}}</b>: {{ selectLocalType(project, project.local_exec_type, 'exec') }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>Nível Territorialização dos beneficiários (de onde são os beneficiários)</b>: {{ execComboType(listData?.localBenTypelist, project.local_ben_type, 'Estado') }}
                  </div>
              </div>
              <div class="control-group">
                  <div class="control-label">
                    <b>{{execComboType(listData?.localBenTypelist, project.local_ben_type, 'Estado')}}</b>: {{ selectLocalType(project, project.local_ben_type, 'ben') }}
                  </div>
              </div>
              <h3>IV - Prazo do projeto</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Prazo do Projeto (meses)</b>: {{ project.exec_duration }}
                  </div>
              </div>
              <h3>V - Custo do projeto</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Custo total estimado (R$)</b>: {{ project.cost_total | number:'1.2-2' }}
                  </div>
              </div>
              <h3>VI - Processo de Captação</h3>
              <div class="control-group">
                  <div class="control-label">
                    <b>Processo vinculado</b>: {{ listNome(project?.processList, project.process_id, 'Nenhum processo vinculado') }}
                  </div>
              </div>
              <div *ngIf="project?.questionList['rgst'].length > 0">
                <ng-container *ngTemplateOutlet="questionList;
                  context: { data:project?.questionList['rgst'] } ">
                </ng-container>
              </div>
          </form>
      </div>
    </div>
    <div class="row-fluid box-title">
      <div class="col-12">
        <h2>Custos</h2>
      </div>
      <hr/>
    </div>
    <div class="row-fluid">
      <div class="col-12">
        <form class="form-horizontal form-lazy-readonly" method="POST">
          <h3>CUSTOS / Financiamento</h3>
          <div class="control-group">
              <div class="control-label">
                <b>Custo total estimado (R$)</b>: {{ project.cost_total | number:'1.2-2' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>% Contrapartida</b>: {{ project.perc_loan | number:'1.2-2' }}%
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Valor Concedente/Financiamento (R$)</b>: {{ project.cost_loan | number:'1.2-2' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Valor da Contrapartida (R$)</b>: {{ project.cost_without_loan | number:'1.2-2' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Fonte de recurso da Contrapartida</b>: {{ comboNome(listData?.resourceList, project.resource_id, 'Convênios') }}
              </div>
          </div>
          <h3>Estimativa de impacto orçamentário-financeiro</h3>
          <div class="control-group">
            <div class="control-label">
              <b>O projeto implica em redução de despesas ou aumento de receitas?</b>: {{ project.decreased_spending ? 'Sim' : 'Não' }}
            </div>
          </div>
          <div class="control-group">
            <div class="control-label">
              <b>O projeto implica em aumento de despesas de custeio ou renúncia de receitas?</b>: {{ project.increased_spending ? 'Sim' : 'Não' }}
            </div>
          </div>
          <ul class="breadcrumb ac-breadcrumb clearfix bread-info">
            <li class="active">Em caso afirmativo do item anterior, estime o impacto orçamentário-financeiro (R$) no exercício em que entrará em vigor e nos dois subsequentes.</li>
            <li class="pull-right"></li>
          </ul>
          <div class="responsive-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 7%;">Cód.</th>
                  <th>Item</th>
                  <th style="width: 10%;">Ano 1 (Em R$)</th>
                  <th style="width: 10%;">Ano 2 (Em R$)</th>
                  <th style="width: 10%;">Ano 3 (Em R$)</th>
                  <th style="width: 18%;">Metodologia utilizada</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let custos of project?.mainList">
                  <td>{{ custos.id }}</td>
                  <td>{{ custos.title }}</td>
                  <td>{{ custos.year1 }}</td>
                  <td>{{ custos.year2 }}</td>
                  <td>{{ custos.year3 }}</td>
                  <td>{{ custos.ds_method }}</td>
                </tr>
                <tr *ngIf="sumTotals(project?.mainList) as total">
                  <td>Totais</td>
                  <td></td>
                  <td class="text-right">{{ total.year1 }}</td>
                  <td class="text-right">{{ total.year2 }}</td>
                  <td class="text-right">{{ total.year3 }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="project?.questionList['cust'].length > 0">
            <ng-container *ngTemplateOutlet="questionList;
              context: { data:project?.questionList['cust'] } ">
            </ng-container>
          </div>
        </form>
      </div>
    </div>
    <ng-container *ngFor="let custom of project?.customTabs">
      <div class="row-fluid box-title">
          <div class="col-12">
              <h2>{{ custom.tab_name }}</h2>
          </div>
        <hr/>
      </div>
      <div class="row-fluid">
        <div class="col-12">
          <form class="form-horizontal form-lazy-readonly" method="POST" >
            <div *ngIf="custom?.questions.length > 0">
              <ng-container *ngTemplateOutlet="questionList;
                context: { data:custom?.questions } ">
              </ng-container>
            </div>			
          </form>
        </div>
      </div>
    </ng-container>
    <ng-container *ngTemplateOutlet="docTable;
      context: { data:{'item_name':'Cronogramas', 'data':project?.docs } } ">
    </ng-container>
    <ng-container *ngTemplateOutlet="docTable;
      context: { data:{'item_name':'Documentos', 'data':project?.docs1 } } ">
    </ng-container>
    <div class="row-fluid box-title">
      <div class="col-12">
        <h2>Equipe de Planejamento do Projeto</h2>
      </div>
      <hr/>
    </div>
    <div class="row-fluid">
      <div class="col-12">
      <ul class="breadcrumb ac-breadcrumb clearfix bread-info">
          <li>Equipe de Planejamento do Projeto</li>
          <li class="pull-right"></li>
      </ul>
      <div class="responsive-table">
        <table class="table tbl-actions">
          <thead>
            <tr>
              <th style="width: 7%;">Cód.</th>
              <th>Nome</th>
              <th style="width: 18%;">Responsabilidades</th>
              <th style="width: 15%;">Organização</th>
              <th style="width: 16%;">Departamento</th>
              <th style="width: 12%;">Email</th>
              <th style="width: 12%;">Telefone</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let linha of project.equipList">
              <td>{{ linha.id }}</td>
              <td>{{ linha.name }}</td>
              <td>{{ linha.equip_role_names }}</td>
              <td>{{ linha.organization }}</td>
              <td>{{ linha.department }}</td>
              <td>{{ linha.email }}</td>
              <td>{{ linha.fone }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
    <div class="row-fluid">
      <div class="col-12">
        <form class="form-horizontal form-lazy-readonly" method="POST">
          <h3>Capacidade de Execução</h3>
          <div class="control-group">
              <div class="control-label">
                <b>Possui equipe definida para execução do projeto</b>: {{ project.equip_ready ? 'Sim' : 'Não' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Órgãos públicos envolvidos</b>: {{ project.ds_agency }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Organizações Parceiras</b>: {{ project.ds_organization }}
              </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row-fluid box-title">
      <div class="col-12">
        <h2>Tramitação</h2>
      </div>
      <hr/>
    </div>
    <div class="row-fluid">
      <div class="col-12">
        <form class="form-horizontal form-lazy-readonly" method="POST">
          <h3>Dados do processo</h3>
          <div class="control-group">
              <div class="control-label">
                <b>Resp. Análise Processo</b>: {{ comboNome(listData?.personList, (""+project?.process_analyst).padStart(11, "0")) }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Status do processo</b>: {{ project?.ppProcessStat?.name }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Data conclusão processo</b>: {{ project?.process_dt_conclusion | date:'dd/MM/yyyy' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Projeto Selecionado</b>: {{ project.project_selected ? 'Sim' : 'Não' }}
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Status do projeto</b>: {{ project.ppProcessSubStat?.name }} 
              </div>
          </div>
          <div class="control-group">
              <div class="control-label">
                <b>Posição</b>: {{ project.ppProcessControl?.name }} 
              </div>
          </div>
          <h3>Mensagens</h3>
          <div class="responsive-table">
            <table class="table tbl-actions">
              <thead>
                <tr>
                  <th>Mensagem</th>
                  <th width="18%">Anexos</th>
                  <th width="20%">Enviado em</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let msg of project.msgList">
                  <td>{{ msg.description }}</td>
                  <td>
                    <ng-container *ngFor="let anexo of msg.docList">
                      <p>Arquivo: {{ anexo.name }}</p>
                    </ng-container>
                  </td>
                  <td>
                    <p>{{ msg.user_name }}</p>
                    <p>{{ msg.ctr_dth_inc | date:'dd/MM/yyyy HH:mm:ss' }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</main>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #questionList let-data="data">
  <h5><em>* Campos obrigatórios</em></h5>
  <ng-container *ngFor="let question of data; let i = index">
    <h4 *ngIf="i === 0 || question.tab_group_name !== data[i - 1]?.tab_group_name">{{question.tab_group_name}}</h4>
    <div class="control-group">
      <div class="control-label">
        <b>{{question.title}}</b>: {{jsonArray(question.ds_value)}}
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #docTable let-data="data">
  <div class="row-fluid box-title">
    <div class="col-12">
      <h2>{{data?.item_name}}</h2>
    </div>
    <hr/>
  </div>
  <div class="row-fluid">
    <div class="col-12">
      <ul class="breadcrumb ac-breadcrumb clearfix bread-info">
          <li>{{data?.item_name}}</li>
          <li class="pull-right"></li>
      </ul>
      <div class="responsive-table">
        <table class="table tbl-actions">
          <thead>
            <tr>
              <th class="col-2">Título</th>
              <th class="col-2">Descrição</th>
              <th class="col-2">Tipo Documento</th>
              <th class="col-3">Arquivo</th>
              <th class="col-2">Responsável</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let linha of data.data">
              <td class="col-2">{{ linha.title }}</td>
              <td class="col-2">{{ linha.description }}</td>
              <td class="col-2">{{ linha.type_name }}</td>
              <td class="col-3">{{ linha.name }}</td>
              <td class="col-2">
                <p>{{ linha.user }}</p>
                <p>{{ linha.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>